import React, { createContext, useCallback, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const ToastContext = createContext(() => {});

/** Returns `toast(message, severity?)` — severity defaults to "error". */
export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const show = useCallback(
    (message, severity = "error") => setToast({ message, severity, key: Date.now() }),
    []
  );

  return (
    <ToastContext.Provider value={show}>
      {children}
      <Snackbar
        key={toast?.key}
        open={!!toast}
        autoHideDuration={5000}
        onClose={(_, reason) => { if (reason !== "clickaway") setToast(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={toast?.severity || "error"}
          variant="filled"
          onClose={() => setToast(null)}
          sx={{ borderRadius: "var(--radius-sm)", boxShadow: "var(--shadow-medium)" }}
        >
          {toast?.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}
